import * as React from 'react';
import HelpBlock from '../../../../../components/HelpBlock/index';
import Textarea from '../../../../../components/Textarea/index';
export const ImportTextSection = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Textarea, { value: props.text, onChange: (event) => props.onTextChange(event.target.value), height: "100%" }),
        props.message && React.createElement(HelpBlock, null, props.message)));
};
